import React from 'react';

const sizeOptions = [
  'Extra Small',
  'Small',
  'Medium',
  'Large',
  'Extra Large',
  '2XL',
  '3XL',
  '4XL',
  '5XL',
  '6XL'
];

const StepTShirtSize = ({ data, setData, onNext }) => {
  const handleSelect = (size) => {
    setData(prev => ({
      ...prev,
      tShirtSize: size
    }));
  };

  return (
    <main className="rbt-main-wrapper">
      <div className="container custom-checkout-container">
        <div className="row">
          <div className="">
            <div className="smart-size-container">
              <h2 className="smart-size-title text-center">
                What size t-shirts do you typically wear?
              </h2>

              <div className="smart-size-buttons">
                {sizeOptions.map((size) => (
                  <button
                    key={size}
                    className={`smart-size-btn ${data.tShirtSize === size ? 'active' : ''}`}
                    onClick={() => handleSelect(size)}
                  >
                    {size}
                  </button>
                ))}
              </div>

              <button
                className="smart-size-next"
                onClick={onNext}
                disabled={!data.tShirtSize}
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default StepTShirtSize;
